import { Target,
  Clock,
  UserCheck,
  Flag,
  HelpCircle,
  BookOpen,
  Receipt,
  ChartLine,
  Home,
  Compass
 } from 'lucide-react'

export default function TaskCategoryIcon({ slug }) {
  switch (slug) {
    case 'one-thing-now':
      return <Target size={16} />
    case '30-second-tasks':
      return <Clock size={16} />
    case 'delegable-tasks':
      return <UserCheck size={16} />
    case 'high-priority':
      return <Flag size={16} />
    case 'needs-more-detail':
      return <HelpCircle size={16} />
    case 'things-to-read':
      return <BookOpen size={16} />
    case 'while-you-are-out':
      return <Compass size={16} />
    case 'admin-and-bills':
      return <Receipt size={16} />
    case 'family-home-care':
      return <Home size={16} />
    case 'planning-strategy':
      return <ChartLine size={16} />
    default:
      return <Target size={16} />
  }
}